<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="40" height="40" rx="8" fill="#3A3B59"/>
<path d="M17 6C17 4.89543 17.8954 4 19 4H33C34.1046 4 35 4.89543 35 6V16C35 17.1046 34.1046 18 33 18H19C17.8954 18 17 17.1046 17 16V6Z" fill="url(#paint0_linear_1091_20373)"/>
<rect x="17" y="8" width="18" height="1" fill="#D361E7"/>
<rect x="27" y="6" width="6" height="1" rx="0.5" fill="#B545CA"/>
<rect x="19" y="6" width="1" height="1" rx="0.5" fill="#F4E560"/>
<rect x="27" y="11" width="6" height="1" rx="0.5" fill="#B545CA"/>
<rect x="19" y="11" width="1" height="1" rx="0.5" fill="#7958FF"/>
<rect x="21" y="11" width="1" height="1" rx="0.5" fill="#F4E560"/>
<rect x="27" y="16" width="6" height="1" rx="0.5" fill="#B545CA"/>
<rect x="19" y="16" width="1" height="1" rx="0.5" fill="#F4E560"/>
<rect x="21" y="16" width="1" height="1" rx="0.5" fill="#F4E560"/>
<rect x="17" y="13" width="18" height="1" fill="#D361E7"/>
<path d="M5 24C5 22.8954 5.89543 22 7 22H21C22.1046 22 23 22.8954 23 24V34C23 35.1046 22.1046 36 21 36H7C5.89543 36 5 35.1046 5 34V24Z" fill="url(#paint1_linear_1091_20373)"/>
<rect x="5" y="26" width="18" height="1" fill="#947DFF"/>
<rect x="15" y="24" width="6" height="1" rx="0.5" fill="#7958FF"/>
<rect x="7" y="24" width="1" height="1" rx="0.5" fill="#FFEAFE"/>
<rect x="15" y="29" width="6" height="1" rx="0.5" fill="#7958FF"/>
<rect x="7" y="29" width="1" height="1" rx="0.5" fill="#FFEAFE"/>
<rect x="9" y="29" width="1" height="1" rx="0.5" fill="#FFEAFE"/>
<rect x="15" y="34" width="6" height="1" rx="0.5" fill="#7958FF"/>
<rect x="7" y="34" width="1" height="1" rx="0.5" fill="#FFEAFE"/>
<rect x="9" y="34" width="1" height="1" rx="0.5" fill="#FFEAFE"/>
<rect x="5" y="31" width="18" height="1" fill="#947DFF"/>
<path opacity="0.4" d="M20 27C24.4183 27 28 23.4183 28 19M12 20C12 15.5817 15.5817 12 20 12" stroke="#C9C5D0" stroke-width="2"/>
<defs>
<linearGradient id="paint0_linear_1091_20373" x1="12.5" y1="13.3333" x2="36.4143" y2="9.97917" gradientUnits="userSpaceOnUse">
<stop stop-color="#E4A3FB"/>
<stop offset="1" stop-color="#EC78FF"/>
</linearGradient>
<linearGradient id="paint1_linear_1091_20373" x1="3.52143" y1="30.0208" x2="21.3627" y2="21.5511" gradientUnits="userSpaceOnUse">
<stop stop-color="#492EF3"/>
<stop offset="1" stop-color="#CF69FF"/>
</linearGradient>
</defs>
</svg>
